var map = {
	"./affiliate-program.svg": "6177",
	"./brand-gigastore-logo.svg": "d85c",
	"./brand_poweredby.svg": "f0c3",
	"./credit-card-dent-red.svg": "60c3",
	"./crypto-dent-dent-red.svg": "c7e1",
	"./dent2018-dent-red.svg": "9435",
	"./esim-reseller-api": "5ee1",
	"./esim-reseller-api.json": "5ee1",
	"./esim-reseller-api.yaml": "1ec4",
	"./gigastore-on-finishline.png": "48fe",
	"./icons/account-grey24.svg": "4316",
	"./icons/account-grey56.svg": "97d5",
	"./icons/account-white.svg": "3295",
	"./icons/account-white_new.svg": "40a0",
	"./icons/add-white.svg": "431c",
	"./icons/adjust-grey56.svg": "5a41",
	"./icons/alarm-warning-dent-red.svg": "a0ce",
	"./icons/api-white.svg": "6b84",
	"./icons/arrow-right-filled-white.svg": "2a7f",
	"./icons/back-white.svg": "addf",
	"./icons/calendar-grey24.svg": "1c77",
	"./icons/calendar-lightgrey24.svg": "e7d4",
	"./icons/chart-candle-dark-grey.svg": "3593",
	"./icons/chart-candle-grey.svg": "f242",
	"./icons/check-circle-green.svg": "d370",
	"./icons/check-circle-grey.svg": "fb33",
	"./icons/check-red.svg": "2c9b",
	"./icons/check-white.svg": "5131",
	"./icons/close-circle-grey71.svg": "7eaf",
	"./icons/close-circle-red.svg": "747f",
	"./icons/close-white.svg": "72e4",
	"./icons/coins-fullGrey.svg": "3ee1",
	"./icons/coins-white.svg": "6a24",
	"./icons/coins2-green.svg": "ed9d",
	"./icons/coins2-grey.svg": "1059",
	"./icons/coins2-red.svg": "6753",
	"./icons/coins3-white.svg": "9c5e",
	"./icons/copy-darkGrey.svg": "7f69",
	"./icons/copy-gray.svg": "1ae3",
	"./icons/copy-red.svg": "8eb6",
	"./icons/copy-white.svg": "d787",
	"./icons/credit-card-grey24.svg": "c4fe",
	"./icons/crypto-dent-white.svg": "8ddc",
	"./icons/dashboard2-fullGrey.svg": "99c2",
	"./icons/dashboard2-white.svg": "605f",
	"./icons/delete-grey.svg": "d8f7",
	"./icons/delete-grey24.svg": "986c",
	"./icons/delete-red.svg": "9cdc",
	"./icons/docs-white.svg": "0655",
	"./icons/download-dent-red.svg": "f83a",
	"./icons/download-grey24.svg": "c590",
	"./icons/download-grey56.svg": "a3e8",
	"./icons/download-white.svg": "d959",
	"./icons/dropdown-blob-darkgrey.svg": "be74",
	"./icons/dropdown-blob-grey.svg": "f215",
	"./icons/dropdown-blob-lightgrey.svg": "2277",
	"./icons/earn-coin-white.svg": "6343",
	"./icons/edit-dent-gray.svg": "926f",
	"./icons/edit-dent-red.svg": "8b43",
	"./icons/esim-grey.svg": "04f9",
	"./icons/esim-install-orange.svg": "dde1",
	"./icons/esim-red.svg": "7cfd",
	"./icons/esim-white.svg": "05ed",
	"./icons/eye-visible-white.svg": "4a52",
	"./icons/file-grey.svg": "8699",
	"./icons/fraud-grey24.svg": "0c43",
	"./icons/globe-grey56.svg": "cd25",
	"./icons/globe-nav-chevron-down-darkgrey.svg": "5521",
	"./icons/globe-nav-chevron-down-grey.svg": "e749",
	"./icons/globe-nav-chevron-right-dent-red.svg": "39c4",
	"./icons/globe-nav-chevron-right-fullGrey.svg": "4d40",
	"./icons/globe-nav-chevron-right-grey56.svg": "86dd",
	"./icons/globe-nav-chevron-right-white.svg": "032c",
	"./icons/globe-nav-chevron-up-darkgrey.svg": "74db",
	"./icons/globe-nav-chevron-up-down-grey.svg": "5edf",
	"./icons/globe-nav-chevron-up-grey.svg": "b110",
	"./icons/graph-bar-fullGrey.svg": "b132",
	"./icons/graph-bar-white.svg": "046f",
	"./icons/graph-line-black.svg": "b926",
	"./icons/graph-line-grey.svg": "1f94",
	"./icons/hourglass-dent-red.svg": "e003",
	"./icons/hourglass-grey24.svg": "c65f",
	"./icons/hourglass-grey56.svg": "9ea7",
	"./icons/info-fullGrey.svg": "3732",
	"./icons/info-grey.svg": "0542",
	"./icons/investment-history-fullGrey.svg": "d457",
	"./icons/investment-history-grey56.svg": "5051",
	"./icons/investment-history-white.svg": "0407",
	"./icons/light-on-dent-red.svg": "85ce",
	"./icons/lock-open-red.svg": "2029",
	"./icons/lock-open-white.svg": "7f23",
	"./icons/lock-red.svg": "3c7d",
	"./icons/logout-grey56.svg": "90d2",
	"./icons/logout-white.svg": "aa8d",
	"./icons/market-place-fullGrey.svg": "360c",
	"./icons/market-place-white.svg": "4ae7",
	"./icons/mobile-data-2-grey.svg": "2eb9",
	"./icons/mobile-data-grey24.svg": "56928",
	"./icons/mobile-data2-grey24.svg": "f89f",
	"./icons/nav_page_first.png": "c6ae",
	"./icons/nav_page_last.png": "cb11",
	"./icons/nav_page_next.png": "ad18",
	"./icons/nav_page_prev.png": "b2f6",
	"./icons/plan-expired-red.svg": "dc3c",
	"./icons/plus-white.svg": "7e53",
	"./icons/present-white.svg": "e907",
	"./icons/pricing-esim.svg": "da9b",
	"./icons/qrcode-grey24.svg": "dd33",
	"./icons/rocketman-green.svg": "db86",
	"./icons/rocketman-white.svg": "6132",
	"./icons/sdk-white.svg": "975a",
	"./icons/share-white.svg": "b943",
	"./icons/shopping-cart-green.svg": "bc59",
	"./icons/shopping-cart-grey.svg": "3874",
	"./icons/shopping-cart-white.svg": "dd76",
	"./icons/smartphone-grey24.svg": "e280",
	"./icons/support-grey24.svg": "6507",
	"./icons/wallet-white.svg": "52cb",
	"./icons/warning2-dent-red.svg": "1d13",
	"./illustrations-API.svg": "b7b8",
	"./illustrations-SDK.svg": "1d18",
	"./illustrations-discount-alternative.svg": "1d42",
	"./illustrations-discount.svg": "5eb8",
	"./illustrations-empty_data.svg": "0450",
	"./illustrations-error.svg": "0cec",
	"./illustrations-fail.svg": "9bfe",
	"./illustrations-gift.png": "5cd4",
	"./illustrations-money.svg": "0374",
	"./illustrations-rocket.svg": "987e",
	"./illustrations-sold-out.svg": "f2f1",
	"./illustrations-spreadsheet.svg": "43f8",
	"./illustrations-store.svg": "a26c",
	"./illustrations-storebatch.svg": "8c79",
	"./illustrations-success.svg": "e3dd",
	"./logo.svg": "9b19",
	"./paypal-dent-red.svg": "11dc",
	"./powered-by.svg": "0fe3",
	"./pricing-banner-graphics-mobile.svg": "935d",
	"./pricing-banner-graphics.svg": "b697",
	"./shopify.svg": "ddb2",
	"./teams.svg": "b726",
	"./telegram.svg": "7dd3",
	"./whatsApp.svg": "f475"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";